'use strict'

import Vue from 'vue'

import pubsub from 'pubsub-js'

const defaults = {

}

// todo: bunch multiple getConfig in one http request

class ConfigClass {

  constructor (options = {}) {
    this.configs = {}
    this.queueCfgs = []
    this.queueTimer = null
    this.loadingCfgs = {}
    this.waitList = {}
    this.resolvedCfgs = {}

    this.options = Object.assign({}, defaults, options)

    this.setStore()
    this.setVariables()
    this.setListeners()
  }

  setStore () {
    this.store = null
  }

  setVariables () {
    this.route = {
      getConfigs : 'mod/config/getConfigs',
      save : 'mod/config/save',
      pubsubUpdated : 'config:updated',
    }
    this.storePath = 'Config'
    this.configRoom = 'admin'
  }

  setListeners () {
    pubsub.subscribe(this.route.pubsubUpdated, (e, { name, val }) => {
      const prefix = 'db:'
      if (name.indexOf(prefix) === 0) {
        name = name.substr(prefix.length)
      }

      this._setConfigVal(name, val)
    })
  }

  updateOptions (options = {}) {
    this.options = Object.assign({}, this.options, options)
  }

  setConfigVal (name = '', val = '') {
    this._setConfigVal(name, val)
  }

  _setConfigVal (name = '', val = '') {
    this.configs[name] = val
    this.resolvedCfgs[name] = Promise.resolve(val)

    if (this.store) this.store.commit(`${this.storePath}/setConfig`, { name, val })
  }

  saveConfigVal (name = '', val = '') {
    this.setConfigVal(name, val)
    return this._saveConfigVal(name, val)
  }

  _saveConfigVal (name = '', val = '') {
    return Vue.http.post(this.route.save, {
      name: `db:${name}`,
      val : val,
      room: this.configRoom
    })
      .then(res => res.body)
      .then(data => {
        //
        return data
      })
  }

  queueConfig (name = '') {
    if (this.queueCfgs.indexOf(name) === -1) {
      this.queueCfgs.push(name)

      this.runQueueTimeout()
    }

    return this.putToWaitList(name)
  }

  runQueueTimeout (force = false) {
    if (this.queueTimer && !force) return

    if (this.queueTimer) {
      clearTimeout(this.queueTimer)
    }

    this.queueTimer = setTimeout(() => {
      this.queueTimer = null
      let list = this.queueCfgs
      this.queueCfgs = []
      this.loadConfigList(list)
    }, 10)
  }

  getConfig (name = '') {
    if (this.resolvedCfgs[name]) return this.resolvedCfgs[name]

    if (this.loadingCfgs[name]) {
      return this.putToWaitList(name)
    }

    return this.queueConfig(name)
    // return this.loadConfig(name)
  }

  getConfigList (list = []) {
    let promiseMap = {}
    let loadList = []

    for (let name of list) {
      let promise

      if (this.resolvedCfgs[name]) {
        promise = this.resolvedCfgs[name]
      } else {
        promise = this.putToWaitList(name)

        loadList.push(name)
      }

      promiseMap[name] = promise
    }

    this.loadConfigList(loadList)

    let promiseList = []

    for (let name in promiseMap) {
      promiseList.push(promiseMap[name])
    }

    return Promise.all(promiseList)
      .then(list => {
        let map = {}

        for (let name in promiseMap) {
          map[name] = list.shift()
        }

        return map
      })
  }

  putToWaitList (name = '') {
    if (!this.waitList[name]) this.waitList[name] = []

    return new Promise((resolve, reject) => {
      this.waitList[name].push({
        name,
        resolve,
        reject,
      })
    })
  }

  loadConfig (name = '') {
    let list = [name]

    return this.loadConfigList(list)
      .then(map => {
        for (let name in map) {
          if (map.hasOwnProperty(name)) return map[name]
        }

        throw new Error(`Config '${name}' is not loaded`)
      })
  }

  loadConfigList (list = []) {
    if (!list || !Array.isArray(list)) throw new Error('Config names are not specified')

    if (!list.length) return Promise.resolve({})

    for (let name of list) this.loadingCfgs[name] = true

    return Vue.http.post(this.route.getConfigs, {cfgs : list})
      .then(res => res.body)
      .then(data => {
        this.parseItemMap(data)

        this.onLoadedConfigs(data, list)

        return data
      })
  }

  parseItemMap (data) {
    for (let name in data) {
      if (data.hasOwnProperty(name)) {
        if (data[name] === '1' || data[name] === '0') data[name] = data[name] | 0
      }
    }
  }

  onLoadedConfigs (data, list) {
    for (let name of list) {
      delete this.loadingCfgs[name]

      let val = data[name]

      if (val !== undefined) {
        this._setConfigVal(name, val)
      }

      if (this.waitList[name]) {
        for (let waiter of this.waitList[name]) {
          if (val !== undefined) {
            waiter.resolve(val)
          } else {
            waiter.reject(`Config '${name}' is not loaded`)
          }
        }

        delete this.waitList[name]
      }
    }
  }
}

export default ConfigClass
